import initialState from '../initialState.js';
import {
    GET_CLAIMS,
    ADD_CLAIM_SUCCESS
} from '../../actions/types/claims';

export default (state = initialState.claims, action) => {
    switch (action.type) {
        case GET_CLAIMS: {
            return {
                ...state,
                items: action.claims
            };
        }

        case ADD_CLAIM_SUCCESS: {
            return {
                ...state,
                items: [
                    action.claim,
                    ...state.items
                ]
            };
        }

        default:
            return state;
    }
};